import { PureComputed } from 'knockout';
import { injectable, inject } from 'inversify';

import { Tool, ToolVM } from '../tool';
import { wccModules } from 'enums/wccModules';

import './icon.html';

export class IconTool extends Tool {
    component = 'chat-editor-icon-tool'
}

@injectable()
export default class IconToolVM extends ToolVM {
    icon: PureComputed<string | undefined>

    constructor(
        @inject(wccModules.componentConfig) model: IconTool,
        @inject(wccModules.componentInfo) info: ko.components.ComponentInfo
    ) {
        super(model, info.element);

        this.icon = ko.observable(model.icon).unwrap();
    }
}